
export class ComputedAvailability {
  constructor(item) {
    this.item = item
  }

  execute() {
    let freeSlots = this.getFreeSlots()
    let computedChanges = this.getComputeChanges(this.item.changes, freeSlots)
    return {
      id: this.item.id,
      username: this.item.username,
      max_reserved_students: this.item.max_reserved_students,
      currently_reserved_students: this.item.currently_reserved_students,
      changes: computedChanges,
      freeSlots: freeSlots
    }
  }

  getFreeSlots() {
    if(this.item.max_reserved_students < this.item.currently_reserved_students) return 0
    return this.item.max_reserved_students - this.item.currently_reserved_students
  }

  getComputeChanges(changes, freeSlots) {
    let computedChanges = {...changes}
    
    for(let date in computedChanges) {
      computedChanges[date] = {
        change: computedChanges[date],
        count: freeSlots
      }
    }

    Object.keys(computedChanges)
      .sort( (a, b) => new Date(a) - new Date(b))
      .reduce( (a, b) => {
        computedChanges[b].count =  a + computedChanges[b].change
        return computedChanges[b].count
      }, freeSlots)
    return computedChanges
  }
}